// API URL configuration - ALWAYS use relative URLs
// The setupProxy.js handles proxying /api/* to localhost:5001
// This works for both local dev AND Cloudflare Tunnel access
export const API_URL = '';
export const MAIN_BACKEND_URL = '';

export function adminSessionHeaders() {
  try {
    const t = localStorage.getItem('sessionToken');
    return t ? { 'X-Admin-Session': t } : {};
  } catch {
    return {};
  }
}
